module["exports"] = ["van", "van de", "van den", "van 't", "van het", "de", "den"];